(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("manageOnlineExams", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/evaluations/onlineExams/manageOnlineExamsView.html",
            controller: ["authService", "$localStorage", "$sessionStorage", "$timeout", "$scope", "$state", "$translate", "DTOptionsBuilder", ManageOnlineExamsCtrl],
            controllerAs: "vm"
        };
        function ManageOnlineExamsCtrl(authService, $localStorage, $sessionStorage, $timeout, $scope, $state, $translate, DTOptionsBuilder) {
            var vm = this;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtInstances = [];
            vm.dtInstance = {};
            vm.statuses = [
                { "id": 0, "status": "Disabled" },
                { "id": 1, "status": "Assigned" },
                { "id": 2, "status": "Activated" },
                { "id": 3, "status": "Completed" },
                { "id": 4, "status": "Expired" }
            ];
            if ($sessionStorage.manageOnlineExamsFilters2) {
                vm.filters = $sessionStorage.manageOnlineExamsFilters2;
            }
            else {
                vm.filters = {
                    firstName: { enabled: true, value: "" },
                    lastName: { enabled: true, value: "" },
                    email: { enabled: false, value: "" },
                    itemName: { enabled: true, value: "" },
                    itemCode: { enabled: false, value: "" },
                    status: { enabled: true, value: [] }
                };
            }
            var tableReloading = false;
            var reloadTableTimeout;
            vm.reloadTable = function () {
                if (tableReloading) {
                    if (reloadTableTimeout)
                        $timeout.cancel(reloadTableTimeout);
                    reloadTableTimeout = $timeout(function () {
                        vm.reloadTable();
                    }, 200);
                }
                else {
                    tableReloading = true;
                    $sessionStorage.manageOnlineExamsFilters2 = vm.filters;
                    vm.dtInstance.reloadData(function () {
                        $timeout(function () {
                            tableReloading = false;
                        });
                    });
                }
            };
            vm.refreshFilter = function (value) {
                $sessionStorage.manageOnlineExamsFilters2 = vm.filters;
                // reload only if filtered
                if (value.length > 0)
                    vm.dtInstance.reloadData();
            };
            vm.closeFilter = function (filter) {
                vm.filters[filter].enabled = false;
                vm.refreshFilter(vm.filters[filter].value);
            };
            vm.rowClickHandler = rowClickHandler;
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withOption("ajax", {
                url: "/api/assignments?type=3",
                error: function (error) {
                    if (error.status === 401) {
                        $state.go("main.signIn");
                    }
                    else if (error.status === 403) {
                        $state.go("main.accessDenied");
                    }
                },
                type: "GET",
                headers: {
                    Authorization: "Bearer " + authService.getToken(),
                    CurrentLocalizationId: $localStorage.currentLocalizationId
                },
                data: function (data) {
                    data.columns[0].search.value = "";
                    data.columns[1].search.value = "";
                    data.columns[2].search.value = vm.filters.firstName.enabled ? vm.filters.firstName.value : "";
                    data.columns[3].search.value = vm.filters.lastName.enabled ? vm.filters.lastName.value : "";
                    data.columns[4].search.value = vm.filters.email.enabled ? vm.filters.email.value : "";
                    data.columns[5].search.value = vm.filters.itemName.enabled ? vm.filters.itemName.value : "";
                    data.columns[6].search.value = vm.filters.itemCode.enabled ? vm.filters.itemCode.value : "";
                    data.columns[7].search.value = vm.filters.status.enabled ? vm.filters.status.value.join("|") : "";
                }
            })
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withDataProp("data")
                .withOption("processing", true)
                .withOption("serverSide", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("order", [1, "asc"])
                .withOption("rowCallback", rowCallback)
                .withPaginationType("full_numbers")
                .withBootstrap();
            vm.dtColumns = [
                {
                    "data": null,
                    "defaultContent": "",
                    "class": "control",
                    "orderable": false,
                    "targets": 0
                },
                { "data": "name" },
                { "data": "name", visible: false },
                { "data": "name", visible: false },
                { "data": "email" },
                { "data": "itemName" },
                { "data": "itemCode" },
                {
                    "data": "status",
                    "render": function (data) {
                        return $translate.instant("common.assignmentStatus." + data);
                    }
                }
            ];
            function rowClickHandler(row) {
                $state.go("main.evaluations.onlineExamsHistory", { code: row.itemCode, person: row.personSeq, assignmentId: row.id });
            }
            function rowCallback(nRow, aData) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                $("td:not(.control)", nRow).bind("click", function () {
                    $scope.$apply(function () {
                        vm.rowClickHandler(aData);
                    });
                });
                return nRow;
            }
        }
    });
}());
